import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useLang } from "@/i18n";

export default function About() {
  const { lang } = useLang();
  const t = (tr, en) => (lang === "tr" ? tr : en);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="about-page">
      <div className="flex items-center gap-3 mb-6">
        <Building2 className="text-red-500" size={28} />
        <span className="eyebrow text-red-500">HAKKIMIZDA · Loft Press</span>
      </div>
      <h1 className="headline text-5xl sm:text-6xl text-white text-balance">
        {t("Loft Press", "About Loft Press")}
      </h1>

      <div className="mt-12 space-y-8 text-base text-neutral-300 leading-relaxed">
        <p>
          {t(
            "Loft Press, halka açık editoryal haber portalı ile yapay zekâ destekli içerik üretim ve API hizmetleri sunan Loft Press Ltd tarafından işletilmektedir.",
            "Loft Press is operated by Loft Press Ltd, which provides a public editorial news portal as well as AI-assisted content-generation and API services."
          )}
        </p>
        <p>
          {t(
            "Ücretli API kapsamında içerikler Loft Press operatörü tarafından belirlenen konu ve başlıklardan oluşturulur, otomatik güvenlik kontrollerinden geçirilir ve manuel editoryal onaydan sonra müşterilere sunulur.",
            "Within the paid API, content is created from topics and titles selected by the Loft Press operator, processed through automated safety controls and delivered to customers only after manual editorial approval."
          )}
        </p>
        <p className="text-neutral-400">
          {t(
            "Halka açık editoryal haber portalı ile ücretli içerik üretim API'si ayrı hizmetlerdir. Halka açık portalda görüntülenebilecek üçüncü taraf kaynaklı içerikler ücretli API paketlerine dahil edilmez.",
            "The public editorial news portal and the paid content-generation API are separate services. Third-party sourced content that may appear on the public portal is not included in the paid API plans."
          )}
        </p>
      </div>

      <div className="mt-12 pt-8 border-t border-neutral-800 flex flex-wrap gap-4 text-sm">
        <Link to="/pricing" className="text-red-500 hover:underline" data-testid="about-pricing">
          {t("API Planları", "API Plans")} →
        </Link>
        <Link to="/marketplace/docs" className="text-neutral-400 hover:text-red-500">
          {t("Dokümantasyon", "Documentation")} →
        </Link>
        <Link to="/contact" className="text-neutral-400 hover:text-red-500">
          {t("İletişim", "Contact")} →
        </Link>
      </div>
    </div>
  );
}
